type Choice = {
  choice: string;
  isCorrect: boolean;
};

export const generateChoices = (
  count: number,
  correctAnswer: string
): Choice[] => {
  const choices: Choice[] = [];

  for (let i = 0; i < count; i++) {
    const choice = String.fromCharCode(65 + i);
    const isCorrect = choice === correctAnswer;

    choices.push({ choice, isCorrect });
  }

  return choices;
};
